export default __webpack_public_path__ + "5e74cb17e93616f2cd1a0aef3b7142e3.jpg";